import React, { useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import {
  StyledAudienceOpener,
  StyledAudienceOpenerContent,
} from './StyledAudienceOpener';
import AudienceOpenerContent from './AudienceOpenerContent';

const AudienceOpener = ({ app, isDisabled, onItemDragEnter, onItemDrop }) => {
  const droppingEntities = useSelector(
    state => state.repository.droppingEntities
  );
  const [isDropping, setIsDropping] = useState(false);

  const isEntityDropping = useMemo(
    () => isDropping || droppingEntities?.[app.name]?.length > 0,
    [droppingEntities, app.name, isDropping]
  );

  const handleDrop = useCallback(
    e => {
      if (isDisabled) return;

      setIsDropping(false);
      onItemDrop(e, app.name);
    },
    [isDisabled, onItemDrop, app.name]
  );

  const handleDragEnter = useCallback(() => {
    if (isDisabled) return;

    setIsDropping(true);
    onItemDragEnter();
  }, [isDisabled, onItemDragEnter]);

  const handleDragOver = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragLeave = useCallback(() => setIsDropping(false), [isDisabled]);

  return (
    <StyledAudienceOpener
      onDrop={handleDrop}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      isDropping={isEntityDropping}
      isDisabled={isDisabled}
      appName={app.name}
    >
      <StyledAudienceOpenerContent
        appName={app.name}
        isDropping={isEntityDropping}
        isDisabled={isDisabled}
      >
        <AudienceOpenerContent
          app={app}
          isDisabled={isDisabled}
          isDropping={isEntityDropping}
        />
      </StyledAudienceOpenerContent>
    </StyledAudienceOpener>
  );
};

AudienceOpener.defaultProps = {
  onItemDragEnter: () => {},
  onItemDrop: () => {},
};

export default AudienceOpener;
